import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { forkJoin, Subscription } from 'rxjs';
import { GeneralService } from 'src/app/services/General.service';
import { MarketInfoService } from 'src/app/services/MarketInfoService.service';
import { ICountry, IStates } from 'src/app/Shared/models/GeneralModel';
import { IVendorProductModel } from 'src/app/Shared/models/VendorModel';
import { VendorAppService } from 'src/app/services/VendorApp.service';
import { ToastrService } from 'ngx-toastr';
import { RentalService } from 'src/app/services/Rental.service';
import { VendorService } from 'src/app/services/Vendor.service';
import { DatePickerComponent, RenderDayCellEventArgs } from '@syncfusion/ej2-angular-calendars';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-vendor-application',
  templateUrl: './vendor-application.component.html',
  styleUrls: ['./vendor-application.component.scss']
})
export class VendorApplicationComponent {
  MarketId: any;
  showStateDropDown: boolean = true;
  loaderIcon: Promise<boolean>;
  marketName: any;
  private subscriptions: Subscription[] = [];
  VendorAppForm: FormGroup;
  countryList: ICountry[] = [];
  StateList: IStates[] = [];
  VendorProductsList: IVendorProductModel[] = [];
  public PhoneNumberMask: String = '000-000-0000';
  public ZipCodeMask: String = '00000-0000';
  public ProductDropDownfields: Object = { text: 'ProductName', value: 'ProductId' };
  public StateDropDownfields: Object = { text: 'StateCode', value: 'StateCode' };
  productList: any[] = [];
   companyId:number;
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };
  response: any;
  rules: any[] = [];
  minDate: Date;
  VendorGeneralSetting: { IsVendorIdManual: any; VendorAddressMandatory: any; AllowAbsenteeRefund: any; TermForLease: any; DefaultProductEnabled: any; Product: any; ResaleNumberRequired: any; DaysToSellWithoutResaleNo: any; BusinessLicenseNumberReq: any; DaysToSellWithoutBusinessLicenseNo: any; AlphaNumericField1Reqd: any; AlphaNumericField2Reqd: any; AlphaNumericField1Name: any; AlphaNumericField2Name: any; NumericField1Reqd: any; NumericField2Reqd: any; NumericField1Name: any; NumericField2Name: any; VendorNameFormat: any; VendorNameFormatId: any; BoothTerm: any; };
  AllowBookingsDaily: any;
  AllowBookingsMonthly: any;
  AllowBookingsCm: any;
  AllowBookingsWeekly: any;
  AllowBookingsCw: any;
  anyRentalTypeEnabledForBooking: any;
  enabledRentalTypes: any;
  checkallrules=false
  marketDaySettings: any;
  selectedMarketDays: any[] = [];
  webRentalSetting: any;
  caseCode: number = 0;
  formatId = 0;
  showZipCodeAsTxt: boolean = false;
  public DropDownfieldsState: Object = { text: 'StateCode', value: 'StateCode' };
  AddressMandatory: boolean = false;
  LastNameMandatory: boolean = false;
  WorkPhoneMandatory: boolean = false;
  CellPhoneMandatory: boolean = false;
  EmailMandatory: boolean = false;

  constructor(private route: ActivatedRoute, public datePipe: DatePipe,
    private marketInfoService: MarketInfoService, private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private toastr: ToastrService,
    private router:Router,
    private vendorApplicationService: VendorAppService,
    public rentalService: RentalService,
    public vendorService: VendorService
  ) { }

  ngOnInit(): void {

    this.VendorAppForm = this.formBuilder.group(
      {
        FirstName: ['', [Validators.required, Validators.maxLength(50)]],
        MiddleName: ['', [Validators.maxLength(50)]],
        LastName: ['', [Validators.maxLength(50)]],
        Email: ['', [Validators.maxLength(40), Validators.pattern('^(([\\w+-.%]+)@([\\w-.]+)\\.([A-Za-z]{2,}))([\\s]?[,;]{1}[\\s]?([\\w+-.%]+)@([\\w-.]+)\\.([A-Za-z]{2,})){0,4}$')]],
        WorkPhone: [''],
        CellPhone: ['', [Validators.minLength(10), Validators.maxLength(12)]],
        Address: ['', [Validators.maxLength(50)]],
        City: [''],
        State: [''],
        ZipCode: [''],
        Country: ['US'],
        Daily: [false],
        Monthly: [false],
        Weekly: [false],
        CombinedMonthly: [false],
        CombinedWeekly: [false],
        IsElectricityRequired: [false],
        PermanentVendor: [false],
        AboutUs: ['', Validators.required],
        SpaceRequiredByDate: [Validators.required],
        ProductPriority: [null, Validators.required],
        rules: this.formBuilder.array(this.initializeRulesArray())
      });

    this.route.params.subscribe((params: Params) => {
      this.MarketId = params.marketId;
      this.minDate = new Date();
      this.getMarketDetails();
      this.getallproducts(this.MarketId);
      this.getCountries();
      this.getStates();
      this.getVendorGeneralSettings();
      this.getWebRentalSetting();
      this.getMarketRulesAndRegulations();
      this.GetMarketDaysSettings();
      this.getVendorCityNameCaseFormat(this.MarketId);
      this.getVendorNameCaseFormat(this.MarketId);
      this.getWebRentalSettingdetails(this.MarketId);
    });
  }

  allCheckboxesCheckedValidator() {
    var allChecked = this.VendorAppForm.value['rules'].filter((e:any) => !e.isChecked).length > 0 ? false : true;
    return allChecked;
  }

  updateArrayDirectly(index: number, updatedValue: any) {
    const isChecked = (event?.target as HTMLInputElement).checked;
    const control = this.rulesFormArray.at(index);
    if (control) {
      this.VendorAppForm.value['rules'][index].isChecked = isChecked;
    }
  }

  get rulesFormArray() {
    return this.VendorAppForm.value['rules'] as FormArray;
  }

  initializeRulesArray(): FormGroup[] {
    return this.rules.map(rule => this.formBuilder.group({
      isChecked: [false],
      rulesAndRegualtions: [rule.rulesAndRegualtions],
      AgreementLinkRequired: [rule.AgreementLinkRequired],
      AgreementBlobURL: [rule.AgreementBlobURL],
      AgreementLinkTextContent: [rule.AgreementLinkTextContent]
    }));
  }

  // checkMarketDay() {
  //   const selectedDayOfWeek = new Date(this.VendorAppForm.controls['SpaceRequiredByDate'].value).getDay();
  //   if (!this.selectedMarketDays.includes(selectedDayOfWeek + 1)) {
  //     Swal.fire({
  //       title: $localize`Warning`,
  //       text: $localize`Selected day is not a market day`,
  //       icon: "warning",
  //       confirmButtonText: $localize`Ok`,
  //     });
  //   }
  // }

  onRenderDayCell(args: RenderDayCellEventArgs): void {
    const date = args.date;
    const day = date?.getDay();

    // Check if the date exists in ExclusiveMarketDays
    const exclusiveDate = this.marketDaySettings.ExclusiveMarketDays.find((d: any) =>
      new Date(d.ExclusiveDate).toDateString() === date?.toDateString()
    );

    if (exclusiveDate) {
      if (exclusiveDate.ExcludedDate) {
        args.isDisabled = true;
        return;
      }

      if (exclusiveDate.AdditionalDate) {
        args.isDisabled = false;
        return;
      }
    }

    switch (day) {
      case 0: // Sunday
        if (!this.marketDaySettings.Sunday) args.isDisabled = true;
        break;
      case 1: // Monday
        if (!this.marketDaySettings.Monday) args.isDisabled = true;
        break;
      case 2: // Tuesday
        if (!this.marketDaySettings.Tuesday) args.isDisabled = true;
        break;
      case 3: // Wednesday
        if (!this.marketDaySettings.Wednesday) args.isDisabled = true;
        break;
      case 4: // Thursday
        if (!this.marketDaySettings.Thursday) args.isDisabled = true;
        break;
      case 5: // Friday
        if (!this.marketDaySettings.Friday) args.isDisabled = true;
        break;
      case 6: // Saturday
        if (!this.marketDaySettings.Saturday) args.isDisabled = true;
        break;
    }
  }

  GetMarketDaysSettings() {
    const sub = this.marketInfoService.getMarketDays(this.MarketId).subscribe((res: any) => {
      if (res) {
        this.marketDaySettings = res;
        this.selectedMarketDays = [];
        res.Sunday ? this.selectedMarketDays.push(1) : 0;
        res.Monday ? this.selectedMarketDays.push(2) : 0;
        res.Tuesday ? this.selectedMarketDays.push(3) : 0;
        res.Wednesday ? this.selectedMarketDays.push(4) : 0;
        res.Thursday ? this.selectedMarketDays.push(5) : 0;
        res.Friday ? this.selectedMarketDays.push(6) : 0;
        res.Saturday ? this.selectedMarketDays.push(7) : 0;

        const today = new Date();
        let foundDate = null;
        let marketDay = new Date(today);

        while (!foundDate) {
          const dayOfWeek = marketDay.getDay();
          const isNormalMarketDay = this.selectedMarketDays.includes(dayOfWeek+1);

          const exclusiveDate = this.marketDaySettings.ExclusiveMarketDays.find((d: any) =>
            new Date(d.ExclusiveDate).toDateString() === marketDay.toDateString() && (d.ExcludedDate != false || d.AdditionalDate!= false)
          );

          let isDateAllowed = false;

          if (exclusiveDate) {
            if (exclusiveDate.ExcludedDate) {
              isDateAllowed = false;
            } else if (exclusiveDate.AdditionalDate) {
              isDateAllowed = true;
            }
          } else if (isNormalMarketDay) {
            isDateAllowed = true;
          }

          if (isDateAllowed) {
            foundDate = new Date(marketDay);
            this.VendorAppForm.get('SpaceRequiredByDate')?.setValue(foundDate);
          } else {
            marketDay.setDate(marketDay.getDate() + 1);
          }
        }
      }
    }, err => {
    });

    this.subscriptions.push(sub);
  }

  getWebRentalSetting() {
    const sub = this.rentalService.getRentalSettings(this.MarketId).subscribe(
      (resRentalSettings: any) => {
        this.VendorAppForm.patchValue({
          Daily: false,
          Monthly: false,
          Weekly: false,
          CombinedMonthly: false,
          CombinedWeekly: false
        });

        this.subscriptions.push(
          this.marketInfoService.GetEnabledRentalTypesForMarket(this.MarketId).subscribe((res: any) => {
            this.enabledRentalTypes = res;

            this.AllowBookingsDaily = this.enabledRentalTypes.some((rentalType:any) => rentalType.Id === 1);
            this.AllowBookingsMonthly = this.enabledRentalTypes.some((rentalType:any) => rentalType.Id === 2);
            this.AllowBookingsWeekly = this.enabledRentalTypes.some((rentalType:any) => rentalType.Id === 3);
            this.AllowBookingsCm = this.enabledRentalTypes.some((rentalType:any) => rentalType.Id === 4);
            this.AllowBookingsCw = this.enabledRentalTypes.some((rentalType:any) => rentalType.Id === 5);

            const defaultBookingType = resRentalSettings.DefaultRentalType?.toString();

            this.VendorAppForm.patchValue({
              Daily: this.AllowBookingsDaily,
              Monthly: this.AllowBookingsMonthly,
              Weekly: this.AllowBookingsWeekly,
              CombinedMonthly: this.AllowBookingsCm,
              CombinedWeekly: this.AllowBookingsCw
            });
          })
        );
      },
      err => {
        // handle error
      }
    );

    this.subscriptions.push(sub);
  }

  getWebRentalSettingdetails(marketId: any) {
    this.marketInfoService.getWebRentalSetting(marketId).subscribe((response) => {
      this.webRentalSetting = response;
      if (this.webRentalSetting.MandatoryFields != "") {
        const mandatoryFields = this.webRentalSetting.MandatoryFields.split(",").map(Number);
        if (mandatoryFields.includes(245)) {
          this.LastNameMandatory = true;
          this.VendorAppForm.get('LastName')?.setValidators([Validators.required]);
          this.VendorAppForm.get('LastName')?.updateValueAndValidity();
        }
        if (mandatoryFields.includes(246)) {
          this.AddressMandatory = true;

          this.VendorAppForm.get('City')?.setValidators([Validators.required]);
          this.VendorAppForm.get('ZipCode')?.setValidators([Validators.required]);
          this.VendorAppForm.get('State')?.setValidators([Validators.required]);
          this.VendorAppForm.get('Address')?.setValidators([Validators.required]);

          this.VendorAppForm.get('City')?.updateValueAndValidity();
          this.VendorAppForm.get('ZipCode')?.updateValueAndValidity();
          this.VendorAppForm.get('State')?.updateValueAndValidity();
          this.VendorAppForm.get('Address')?.updateValueAndValidity();
        }
        if (mandatoryFields.includes(91)) {
          this.WorkPhoneMandatory = true;
          this.VendorAppForm.get('WorkPhone')?.setValidators([Validators.required]);
          this.VendorAppForm.get('WorkPhone')?.updateValueAndValidity();
        }
        if (mandatoryFields.includes(98)) {
          this.CellPhoneMandatory = true;
          this.VendorAppForm.get('CellPhone')?.setValidators([Validators.required]);
          this.VendorAppForm.get('CellPhone')?.updateValueAndValidity();
        }
        if (mandatoryFields.includes(99)) {
          this.EmailMandatory = true;
          this.VendorAppForm.get('Email')?.setValidators([Validators.required]);
          this.VendorAppForm.get('Email')?.updateValueAndValidity();
        }
      }
    }, (err) => {
      console.log(err);
    });
  }

  getMarketRulesAndRegulations() {
      this.subscriptions.push(this.generalService.getWebrentalMarketRules(this.MarketId).subscribe((rules: any) => {
        if (rules) {
          const rulesArray = this.VendorAppForm.get('rules') as FormArray;
          rules.forEach((rule:any) => {

            var agreementURL = rule.AgreementBlobURL == null ? rule.AgreementBlobURL : "";

            if (!agreementURL) {
              agreementURL = rule.AgreementBlobURL ?? "";
            }

            if (!rule.AgreementLinkRequired || (rule.AgreementLinkRequired && agreementURL)) {
              rulesArray.push(this.formBuilder.group({
                id: rule.ID,
                isChecked: false,
                rulesAndRegualtions: rule.Rules,
                AgreementLinkRequired : rule.AgreementLinkRequired ?? false,
                AgreementLinkTextContent: rule.AgreementLinkTextContent ?? "",
                AgreementBlobURL: agreementURL
              }));
            }
          });
        }
      }));
    }

  getMarketDetails() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.marketInfoService.getMarketDetails(this.MarketId).subscribe((res: any) => {
      if (res) {
        this.marketName = res.MarketName;
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  getallproducts(marketId: any) {

    this.subscriptions.push(this.marketInfoService.GetAllMarketProducts(marketId).subscribe((res: any) => {
      this.productList = [];
      res.map((el:any, i:any) => {
        const ob = {
          ProductId: el.ProductId,
          ProductName: el.ProductName,
          ProductCategory: el.ProductCategory,
          ProductCategoryId: el.ProductCategoryId,
          IsInActive: el.IsInActive,
          CompanyProductId: el.CompanyProductId,
        }

        this.productList.push(ob);

      });
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  onCountryChange() {

    const selectedCountry = this.countryList.find(ct => ct.Name == this.VendorAppForm.value['Country']);
    if (selectedCountry != undefined || selectedCountry != null) {
      this.showStateDropDown = true;
      this.showZipCodeAsTxt = true;
      if (selectedCountry.Code != 1) {
        this.StateList = [];
        this.subscriptions.push(this.generalService.GetCountryStateList(selectedCountry.Code).subscribe((response: IStates[]) => {
          this.StateList = response;
          if (this.StateList.length < 1) {
            this.showStateDropDown = false;
          }
        }));
        this.showZipCodeAsTxt = false;
      } else {
        this.getStates();
      }
    }
  }



  DropDownCountryChange(e:any) {
    this.VendorAppForm.patchValue({
      City: '',
      State: '',
      ZipCode: '',
    });

    const selectedCountry = this.countryList.find(ct => ct.Name == this.VendorAppForm.value['Country']);
    if (selectedCountry != undefined || selectedCountry != null) {
      this.showStateDropDown = true;
      this.showZipCodeAsTxt = true;

      if (selectedCountry.Code != 1) {
        this.subscriptions.push(this.generalService.GetCountryStateList(selectedCountry.Code).subscribe((response: IStates[]) => {
          this.StateList = response;
          if (this.StateList.length < 1) {
            this.showStateDropDown = false;
          }
        }));
        this.showZipCodeAsTxt = false;
      } else {
        this.getStates();
      }
    }
  }

  getCountries() {
    const sub = this.generalService.getCountries().subscribe((response: ICountry[]) => {
      this.countryList = response;
    });
    this.subscriptions.push(sub);
  }

  getStates() {
    this.StateList = []
    this.subscriptions.push(this.generalService.getUSStates().subscribe((response: IStates[]) => {
      this.StateList = response;
      if (this.StateList.length < 1) {
        this.showStateDropDown = false;
      }
    }));
  }

  primaryproductchange(args1:any) {
    const Id = args1;
    const product = this.productList.find(p => p.ProductId === Id);

    if (product) {
      this.VendorProductsList.pop();
      const newProduct: IVendorProductModel = {
        VProductId: 0,
        ProductId: product.ProductId,
        Priority: true,
        VendorId: 0,
        ProductName: product.ProductName,
        ProductCategoryId: product.ProductCategoryId,
        ProductCategory: product.ProductCategory,
      };
      this.VendorProductsList.push(newProduct);
    } else {
      console.log("Product not found with ID:", Id);
    }
  }

  Cancel(){
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/ven-app/' + this.MarketId]);
    });
  }

  onSubmit() {
    this.loaderIcon = Promise.resolve(true);
    var allChecked = this.VendorAppForm.value['rules'].filter((e: any) => !e.isChecked).length > 0 ? false : true;
    if (!allChecked) {
      this.toastr.error($localize`Please Check in Rules and Regulation`, $localize`Error`, this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
      return;
    }
    if (this.VendorAppForm.value['FirstName'].trim() == '') {
      this.toastr.error($localize`Vendor first name can't be empty`, $localize`Error`, this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
      return;
    }

    if (!this.VendorAppForm.valid) {
      this.toastr.error($localize`Please check the form!`, $localize`Error`, this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
      return;
    }

    const venapp = {
      FirstName: this.VendorAppForm.value['FirstName'],
      MiddleName: this.VendorAppForm.value['MiddleName'],
      LastName: this.VendorAppForm.value['LastName'],
      Email: this.VendorAppForm.value['Email'],
      WorkPhone: this.VendorAppForm.value['Workphone'],
      CellPhone: this.VendorAppForm.value['CellPhone'],
      Address: this.VendorAppForm.value['Address'],
      City: this.VendorAppForm.value['City'],
      StateCode: this.VendorAppForm.value['State'],
      ZipCode: this.VendorAppForm.value['ZipCode'],
      CountryCode: this.VendorAppForm.value['Country'],
      DailyYes: this.VendorAppForm.value['Daily'],
      MonthlyYes: this.VendorAppForm.value['Monthly'],
      WeeklyYes: this.VendorAppForm.value['Weekly'],
      Cmyes: this.VendorAppForm.value['CombinedMonthly'],
      Cwyes: this.VendorAppForm.value['CombinedWeekly'],
      Electricity: this.VendorAppForm.value['IsElectricityRequired'] ? 1 : 0,
      PerVendor: this.VendorAppForm.value['PermanentVendor'] ? 1 : 0,
      HearAboutUs: this.VendorAppForm.value['AboutUs'],
      SpaceRequireBy: this.VendorAppForm.value['SpaceRequiredByDate'],
      ProductId: this.VendorAppForm.value['ProductPriority'],
      MarketId: this.MarketId,
      VenDtmDateTime: new Date(),
    };

    this.vendorApplicationService.WRSaveVendorApplication(venapp).subscribe({
      next: (response: any) => {
        if (response) {
          this.toastr.success(response.Message, $localize`Success`, this.toasterConfig);
          this.Cancel();
        } else {
          this.toastr.error($localize`Vendor Application Submission Failed!`, $localize`Error`, this.toasterConfig);
        }
        this.loaderIcon = Promise.resolve(false);
      },
      error: (err) => {
        this.toastr.error($localize`An error occurred during submission. Please try again later.`, $localize`Error`, this.toasterConfig);
        this.loaderIcon = Promise.resolve(false);
      }
    });
  }

  getVendorGeneralSettings() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.marketInfoService.getCurrentMarketVendorGeneralSettings(this.MarketId).subscribe((res: any) => {

      if (res) {
        this.VendorGeneralSetting = {
          IsVendorIdManual: res.SpecifyVendorID,
          VendorAddressMandatory: res.VendAddressMandatory,
          AllowAbsenteeRefund: res.BoothStatusRefund,
          TermForLease: res.LeaseLabel,
          DefaultProductEnabled: res.DefaultProductSelected,
          Product: res.ProductId,
          ResaleNumberRequired: res.ResaleNumberRequired,
          DaysToSellWithoutResaleNo: res.DaysSellWithoutResaleNumber,
          BusinessLicenseNumberReq: res.BusinessLicenseNumberRequired,
          DaysToSellWithoutBusinessLicenseNo: res.DaysSellWithoutBusiLicNumber,
          AlphaNumericField1Reqd: res.AlphaNumericField1Reqd,
          AlphaNumericField2Reqd: res.AlphaNumericField2Reqd,
          AlphaNumericField1Name: res.AlphaNumericField1Name,
          AlphaNumericField2Name: res.AlphaNumericField2Name,
          NumericField1Reqd: res.NumericField1Reqd,
          NumericField2Reqd: res.NumericField2Reqd,
          NumericField1Name: res.NumericField1Name,
          NumericField2Name: res.NumericField2Name,
          VendorNameFormat: res.VendorNamingConvention,
          VendorNameFormatId: res.VendorNamingConventionId,
          BoothTerm: res.BoothTerm
        }

        if (this.VendorGeneralSetting.VendorAddressMandatory) {
          this.VendorAppForm.get('City')?.setValidators([Validators.required]);
          this.VendorAppForm.get('ZipCode')?.setValidators([Validators.required]);
          this.VendorAppForm.get('State')?.setValidators([Validators.required]);
          this.VendorAppForm.get('Address')?.setValidators([Validators.required]);

          this.VendorAppForm.get('City')?.updateValueAndValidity();
          this.VendorAppForm.get('ZipCode')?.updateValueAndValidity();
          this.VendorAppForm.get('State')?.updateValueAndValidity();
          this.VendorAppForm.get('Address')?.updateValueAndValidity();
        }
      }
      this.loaderIcon = Promise.resolve(false);
    }));
    this.loaderIcon = Promise.resolve(false);
  }

  getVendorCityNameCaseFormat(marketId: any) {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.vendorService.getVendorCityNameCaseFormat(marketId).subscribe((res: any) => {
      if (res) {
        this.caseCode = res.body.CaseFormatCode;
      }
    }))
  }

  lockStateComboBoxTranslation(): void {
    const popupEl = document.getElementById('StateCombobox_popup');
    if (popupEl) {
      popupEl.setAttribute('translate', 'no');
      popupEl.classList.add('notranslate');
    }
  }

  getVendorNameCaseFormat(marketId: any) {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.vendorService.getVendorNameCaseFormat(marketId).subscribe((res: any) => {
      if (res) {
        this.formatId = res.body.CaseFormatCode
      }
    }))
  }

  companyIdSevenMile(companyId: any){
    this.companyId = companyId
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }

  ngAfterViewInit() {
    this.onCountryChange();
  }

}
